export default __webpack_public_path__ + "static/media/ic_menu_timesheet_manager.eb24f686.svg";